import { ORDER_TYPES, useOrder } from 'context/OrderContext';
// import OrderDialog from 'pages/dashboard/ui/OrderDialog';
import React from 'react'
import OrderDialog from './OrderDialog';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateTableOrderMutation, useUpdateOrderMutation } from 'pages/orders/services';
import { useState } from 'react';
import TablesModal from '../TablesModal';
import { useAddVendorTablesMutation } from 'pages/tables/services';
import AddTimeSlots from '../TimeSlotModals/AddTimeSlots/AddTimeSlots';
import TimeSlotCategory from '../TimeSlotModals/TimeSlotCategory/TimeSlotCategory';

const OrderDialogManager = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { dialogOpen, dialogType, closeDialog, handleContinueClick, dialogPrefill, openDialog, resetOrder } = useOrder();
    const [createTableOrderAPI] = useCreateTableOrderMutation();
    const [updateOrderApi] = useUpdateOrderMutation();
    const [isAddingTable, setIsAddingTable] = useState(false);
    const [isAddingTimeSlot, setIsAddingTimeSlot] = useState(false);
    const [isAddingCategory, setIsAddingCategory] = useState(false);
    const [tempFormData, setTempFormData] = useState(null);
    const [tempAddTimeSlotData, setTempAddTimeSlotData] = useState(null);
    const [activeTimeSlotFormType, setActiveTimeSlotFormType] = useState(null);
    const [storedDialogType, setStoredDialogType] = useState(null);
    const [addTableApi, { isLoading: addingTable }] = useAddVendorTablesMutation();

    const orderTypeMap = {
        takeAway: ORDER_TYPES.TAKE_AWAY,
        dineIn: ORDER_TYPES.DINE_IN,
        tableBooking: ORDER_TYPES.TABLE_BOOKING,
        phoneOrder: ORDER_TYPES.PHONE_ORDER,
    };
    const handleSubmit = async (values) => {
        // console.log("Form submitted:", values)

        if (location.pathname == "/tables") {
            let child_ids = [];
            const nowIso = new Date().toISOString();  // e.g. "2025-07-14T10:30:45.123Z"
            const booking_date = nowIso.split('T')[0];      // "2025-07-14"
            const booking_time = nowIso.split('T')[1].split('.')[0]; // "10:30:45"
            if (dialogPrefill?.table?.merged) {
                dialogPrefill?.table?.children?.map((ele) => {
                    child_ids.push(ele?.id)
                })
            }
            const payload = {
                customer_id: values?.id,
                table_id: values?.table,
                booking_date: booking_date,
                booking_time: booking_time,
                guest_count: values?.persons,
                child_table_ids: child_ids
            }
            const res = await createTableOrderAPI(payload);
            closeDialog();
            // Clear stale customerData so next fresh dialog open starts empty
            resetOrder();
            if (res?.data?.data) {
                // navigate("/order-details", {state:{orderId: res?.data?.data?.order?.id}});
                navigate("/add-item-order", { state: { orderId: res?.data?.data?.order?.id } });
            }
            // Return early — prevents handleContinueClick from firing for the /tables path
            return;
        }
        if (location.pathname == "/order-details") {
            const payload = {
                customer_id: values?.id,
                ...(values?.persons ? { guest_count: values?.persons } : {}),
            };
            const id = dialogPrefill?.table?.order_id || dialogPrefill?.order_id;
            const res = await updateOrderApi({ id: id, body: payload });
        }
        else {
            // Update the order context with the selected type and customer data
            handleContinueClick(orderTypeMap[dialogType], values)
        }

        // Process the form data based on dialog type
        switch (dialogType) {
            case "takeAway":
                console.log("Processing Take Away Order")
                break
            case "dineIn":
                console.log("Processing Dine-In Order")
                break
            case "tableBooking":
                console.log("Processing Table Booking")
                break
            case "phoneOrder":
                console.log("Processing Phone Order")
                break
            default:
                break
        }
        closeDialog();
    }

    const handleOpenAddTable = (values) => {
        setTempFormData(values);
        setStoredDialogType(dialogType);
        closeDialog();
        setIsAddingTable(true);
    };

    const handleAddTableSubmit = async (tableValues) => {
        try {
            const res = await addTableApi(tableValues).unwrap();
            setIsAddingTable(false);
            const newTableId = res?.data?.record?.id || res?.data?.id || res?.data?.table?.id;
            const updatedDraft = {
                ...tempFormData,
                ...(newTableId ? { table: newTableId } : {})
            };
            // Reopen OrderDialog with previous form data
            openDialog(storedDialogType, updatedDraft);
        } catch (error) {
            console.error("Error adding table:", error);
        }
    };

    const handleAddTableClose = () => {
        setIsAddingTable(false);
        // Reopen OrderDialog with previous form data
        openDialog(storedDialogType, tempFormData);
    };

    const handleOpenAddTimeSlot = (values) => {
        setTempFormData(values);
        setStoredDialogType(dialogType);
        closeDialog();
        setIsAddingTimeSlot(true);
    };

    const handleCloseAddTimeSlot = () => {
        setIsAddingTimeSlot(false);
        setTempAddTimeSlotData(null);
        setActiveTimeSlotFormType(null);
        // Reopen OrderDialog with previous form data
        openDialog(storedDialogType, tempFormData);
    };

    const handleOpenAddCategory = (values, formType) => {
        setTempAddTimeSlotData(values);
        setActiveTimeSlotFormType(formType);
        setIsAddingTimeSlot(false);
        setIsAddingCategory(true);
    };

    const handleCloseAddCategory = () => {
        setIsAddingCategory(false);
        if (tempAddTimeSlotData) {
            setIsAddingTimeSlot(true);
        }
    };

    return (
        <>
            <OrderDialog
                open={dialogOpen}
                onClose={closeDialog}
                dialogType={dialogType}
                onSubmit={handleSubmit}
                onAddTable={handleOpenAddTable}
                onAddTimeSlot={handleOpenAddTimeSlot}
            />
            <TablesModal
                open={isAddingTable}
                onClose={handleAddTableClose}
                onSubmit={handleAddTableSubmit}
                loading={addingTable}
            />
            <AddTimeSlots
                open={isAddingTimeSlot}
                onClose={handleCloseAddTimeSlot}
                onAddCategory={handleOpenAddCategory}
                initialData={tempAddTimeSlotData}
                initialFormType={activeTimeSlotFormType}
            />
            <TimeSlotCategory
                open={isAddingCategory}
                onClose={handleCloseAddCategory}
            />
        </>
    )
}

export default OrderDialogManager


